import React from 'react';
import {
  makeStyles,
  createStyles,
  Grid,
} from '@material-ui/core';
import clsx from 'clsx';
import { Spinner } from '../index';

const useStyles = makeStyles(createStyles({
  wrapper: {
    display: 'flex',
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
}), { name: 'LoadingFrame' });

type Props = {
  customClassName?: string;
};

const LoadingFrame = ({ customClassName }: Props) => {
  const classes = useStyles();

  return (
    <Grid container className={clsx(classes.wrapper, customClassName || '')}>
      <Spinner />
    </Grid>
  );
};

export default LoadingFrame;
